import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse } from "types";

import { postQuestionnaireRequestApproveService } from "../api";

export const usePostQuestionnaireRequestApproveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.post_questionnaire_request_approve],
    mutationFn: postQuestionnaireRequestApproveService,
    useErrorBoundary: true,
    onError: (error: ErrorResponse) => errorModal(error),
    onSuccess: payload => {
      queryClient.refetchQueries([QUERY_KEYS.get_questionnaire_request_list]);
      queryClient.refetchQueries([QUERY_KEYS.get_questionnaire_request, payload.data.id]);
    }
  });
};
